export const filter = state => state.filter;
